import { MaintenanceWindowSchedulerSchema } from './maintenanceWindowScheduler/types';
import { RecurrenceOptions } from '../types/common/schedulerTypes';
import { MaintenanceWindowSimpleSchedulerSchema } from './maintenanceWindowSimpleScheduler/types';
import { MaintenanceWindowRebootOptionsData } from './maintenanceWindowRebootOptions/types';
import { PostponeRebootOptions } from '../types/common/maintenanceWindowCommonTypes';
import { getTimezonedCurrentDateTimestamp } from '@nirvana/shared/time';

export class MaintenanceWindowsConstants {
  public static RebootOptions = {
    CustomMessageMaxLength: 128,
  };

  public static MaintenanceWindowName = {
    MinLength: 1,
    MaxLength: 80,
    SchedulerMaxTime: {
      hours: 23,
      minutes: 59,
    },
  };

  public static scanNewScheduleDefaultValues: MaintenanceWindowSchedulerSchema = {
    recurrence: RecurrenceOptions.WEEKLY.toString(),
    weeklyRecurrence: {
      every: '1',
      days: [1, 2, 3, 4, 5, 6, 0],
    },
    startingWith: getTimezonedCurrentDateTimestamp('UTC'),
    between: {
      start: {
        hours: 21,
        minutes: 0,
      },
      end: {
        hours: 23,
        minutes: 59,
      },
    },
  };

  public static scanOldScheduleDefaultValues: MaintenanceWindowSimpleSchedulerSchema = {
    recurrence: RecurrenceOptions.DAILY.toString(),
    daily: {
      at: {
        hours: 21,
        minutes: 0,
      },
    },
  };

  public static securityNewScheduleDefaultValues: MaintenanceWindowSchedulerSchema = {
    recurrence: RecurrenceOptions.IMMEDIATELY.toString(),
    startingWith: getTimezonedCurrentDateTimestamp('UTC'),
    between: {
      start: {
        hours: 21,
        minutes: 0,
      },
      end: {
        hours: 23,
        minutes: 59,
      },
    },
  };

  public static securityOldScheduleDefaultValues: MaintenanceWindowSimpleSchedulerSchema = {
    recurrence: RecurrenceOptions.IMMEDIATELY.toString(),
  };

  public static nonSecurityNewScheduleDefaultValues: MaintenanceWindowSchedulerSchema = {
    recurrence: RecurrenceOptions.WEEKLY.toString(),
    weeklyRecurrence: {
      every: '1',
      days: [4],
    },
    startingWith: getTimezonedCurrentDateTimestamp('UTC'),
    between: {
      start: {
        hours: 21,
        minutes: 0,
      },
      end: {
        hours: 23,
        minutes: 59,
      },
    },
  };

  public static nonSecurityOldScheduleDefaultValues: MaintenanceWindowSimpleSchedulerSchema = {
    recurrence: RecurrenceOptions.WEEKLY.toString(),
    weekly: {
      days: [4], // Thu
      at: {
        hours: 21,
        minutes: 0,
      },
    },
  };

  public static rebootOptionsDefaultValues: MaintenanceWindowRebootOptionsData = {
    rebootOption: PostponeRebootOptions.CUSTOM_TIME.toString(),
    interval: {
      between: {
        start: {
          hours: 0,
          minutes: 0,
        },
        end: {
          hours: 23,
          minutes: 59,
        },
      },
      minutes: '10',
      customMessage: '',
    },
    after: {
      minutes: '10',
      customMessage: '',
    },
  };
}
